import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Flex, Text, Slider } from '@leverege/ui-elements'
import { LabelGroup } from '~/views'

import { GeotileActions } from '~/actions/'
import style from './style.css'

class ImageEditor extends React.Component {
  static propTypes = {
    geotile : PropTypes.object.isRequired,
    imageUrl : PropTypes.string,
    imageLoading : PropTypes.bool
  }

  constructor( props ) {
    super( props )
    this.state = {
      imageHash : `${Date.now()}`
    }
  }

  onSelectImage = ( evt ) => {
    const file = evt.target.files[0]
    if ( !file ) return
    const { geotile, dispatch, projectId } = this.props
    const { metadata = {}, id : geotileId } = geotile
    const body = new FormData()
    body.append( 'sourceImage', file )
    body.append( 'metadata', JSON.stringify( { ...metadata, imageFileName : file.name } ) )
    dispatch( GeotileActions.update( { projectId, geotileId, body } ) )
  }

  render() {
    const { geotile = {}, imageUrl, imageLoading, onChangeOpacity, editorState : { imageLayerOpacity : opacity } } = this.props
    const { sourceImagePath } = geotile

    let thumbnail
    if ( imageLoading ) {
      thumbnail = (
        <Flex justify="center" align="center" className={style.loader}>
          <Flex direction="column">
            <Text>Loading Preview...</Text>
            <i className="fa fa-spin fa-refresh fa-fw" />
          </Flex>
        </Flex>
      )
    } else if ( sourceImagePath ) {
      thumbnail = <img src={imageUrl} />
    }
    return (
      <>
        <Flex variant="vSpace" align="stretch" direction="column">
          {sourceImagePath && <div className={style.thumbnail}>{thumbnail}</div>}
          <div>
            <input 
              onChange={this.onSelectImage} 
              type="file"
              id="mapImageLayer"
              name="mapImageLayer" 
              accept="image/png, image/jpeg"/>
          </div>
        </Flex>
        <LabelGroup className={style.sliderGroup}>
          <label>Layer Opacity</label>
          <Slider 
            min={0} 
            max={100} 
            eventData="image" 
            className={style.slider}
            variant="opacity"
            onChange={onChangeOpacity} 
            value={opacity * 100} />
        </LabelGroup>
      </>
    )
  }
}

export default connect()( ImageEditor )
